import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { confirmAlert } from "react-confirm-alert";
import { connect } from "react-redux";


// components
import PromotionList from "./_list";
import PromotionForm from "./_form";
import PromotionBenefit from "../promotionBenefit/promotionBenefit";
import PromotionTabOption from "../promotionTabOption/promotionTabOption";
import ProductPromotion from "../productPromotion/productPromotion";
import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { ButtonNew, ButtonSync, ButtonUpdPrices } from "../../../components/buttons/buttonsActions";

// labels
import {
    ARE_YOU_SHURE_TITLE, CONFIRM_SYNC, CONFIRM_YES, error, info, NO,
    success, TOAST_SYNC_ALL_PROMOTIONS_PRICES, updateMsg
} from "../../../components/i18n/i18n";

// services
import { promotionService } from "../../../jwt/_services/promotions/promotionService";
import { productPriceService } from "../../../jwt/_services/promotions/productPriceService";
import { langPromotionService } from "../../../jwt/_services/relations/langPromotionService";
import { productPromotionService } from "../../../jwt/_services/promotions/productPromotionService";
import { promotionBenefitService } from "../../../jwt/_services/relations/promotionBenefitService";
import { promotionTabOptionService } from "../../../jwt/_services/relations/promotionTabOptionService";

// actions
import { setForm } from "../../../redux/actions/generalActions/formActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { clearState,  setApp, setCategory, setLoading, setUdn, setViewMode } from "../../../redux/actions/generalActions/mainActions";


const Promotion = (props) => {
    // Modo de vista: LIST, FORM, BENE, TABOPTS, PRODUCTS
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const syncFirebase = () => {
        showToastCustom(info, TOAST_SYNC_ALL_PROMOTIONS_PRICES);
        props.setLoading(true);
        promotionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        langPromotionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        productPromotionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        promotionBenefitService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        promotionTabOptionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        productPriceService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmSyncPromotionsPrices = () => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{CONFIRM_SYNC}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            syncPromotionsPrices()
                            onClose();
                        }}>
                            {CONFIRM_YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const syncPromotionsPrices = () => {
        props.setLoading(true);
        productPriceService.syncPromotionsPrices()
            .then(_ => {
                props.setLoading(false);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const newItem = () => {
        props.setForm()
        props.setViewMode('FORM')
    }

    return (
        <div>
            {loading && showLoader()}
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonUpdPrices onClick={confirmSyncPromotionsPrices}/>
                                    <ButtonSync onClick={syncFirebase}/>
                                    <ButtonNew onClick={newItem}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    {(
                        function() {
                        switch (viewMode) {
                            case "LIST" :
                                return <PromotionList />
                            case "FORM" :
                                return <PromotionForm />
                            case "BENE" :
                                return <PromotionBenefit />
                            case "TABOPTS" :
                                return <PromotionTabOption />
                            case "PRODUCTS" :
                                return <ProductPromotion />
                            default:
                                return null;
                        }
                    })()}
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    formProps: state.formProps,
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setApp,
    setCategory,
    setForm,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(Promotion)
